function getFetchOptions() {
  let {
    headers,
    circuitBreaker,
    ...rest
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    circuitBreaker: {
      timeout: 3000,
      resetTimeout: 30000,
      fallback: {},
      ...circuitBreaker
    },
    headers: {
      'X-fwd-svc': 'atc',
      ...headers
    },
    ...rest
  };
}
export { getFetchOptions as default };
